/**
 * 检查数组value的值是否唯一
 * @param value 需要检查值是否唯一的数组
 */
export var isArrayValueRepeat = function isArrayValueRepeat(value) {
  var hash = {};
  for (var i in value) {
    if (hash[value[i]]) {
      return true;
    }
    hash[value[i]] = true;
  }
  return false;
};
/**
 * 将字符串转为数组
 * @param { string } val - 字符串
 */
export var getStringToArray = function getStringToArray(val) {
  if (val) {
    var result = [];
    val.split(' ').forEach(function (item) {
      if (item !== '') {
        result.push(item);
      }
    });
    return result;
  }
  return [];
};